import React from 'react';
import { useNavigate } from 'react-router-dom';
import awardlogo from '../../Assets/Distinguished Innovator.svg';
import awardlogo2 from '../../Assets/Distinguished Innovation by Private Sector.svg';

const MediaCentreSummary = () => {
    const navigate = useNavigate();

    const awardItems = [
        { text: 'Global Distinguished Innovator', Subtext: "GINI Awards 2025", highlight: false, logo: awardlogo, logo2: null },
        { text: 'CSP.in Wins Dual Global Honors', Subtext: "GINI Awards 2025", logo: awardlogo, logo2: awardlogo2, highlight: true },
        { text: 'Distinguished Innovation by Private Sector', Subtext: "GINI Awards 2025", highlight: false, logo: awardlogo2, logo2: null },
    ];

    return (
        <div className='w-100 my-5'>
            <style>{`
                .awards-container {
                    width: 100%;
                    max-width: 1296px;
                    margin: 0 auto;
                    padding: 8px 0;
                }
                .awards-grid {
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    gap: 24px;
                    width: 100%;
                }
                .award-item {
                    padding: 16px 20px;
                    text-align: center;
                    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                    cursor: pointer;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: flex-start;
                    position: relative;
                }
                /* Elegant vertical separators between columns on desktop */
                .award-item:not(:last-child)::after {
                    content: '';
                    position: absolute;
                    right: -12px;
                    top: 20%;
                    height: 60%;
                    width: 1px;
                    background: linear-gradient(to bottom, transparent, #cbd5e1, transparent);
                }
                .award-item:hover {
                    transform: translateY(-4px);
                }
                .award-logos-wrapper {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    gap: 12px;
                    margin-bottom: 12px;
                    min-height: 80px;
                }
                .award-card-logo {
                    width: 76px;
                    height: 76px;
                    object-fit: contain;
                    transition: transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
                }
                .award-item:hover .award-card-logo {
                    transform: scale(1.1) rotate(2deg);
                }
                .award-card-text {
                    font-size: 15px;
                    font-weight: 700;
                    color: #37546D;
                    margin-bottom: 6px;
                    line-height: 1.4;
                    margin-top: 8px;
                    transition: color 0.3s ease;
                }
                .award-item:hover .award-card-text {
                    color: #00b087;
                }
                .award-card-subtext {
                    font-size: 10px;
                    font-weight: 700;
                    color: #94a3b8;
                    text-transform: uppercase;
                    letter-spacing: 1.2px;
                    transition: color 0.3s ease;
                }
                .award-item:hover .award-card-subtext {
                    color: #37546D;
                }
                @media (max-width: 992px) {
                    .awards-grid {
                        grid-template-columns: repeat(2, 1fr);
                    }
                    .award-item:nth-child(2)::after {
                        display: none;
                    }
                }
                @media (max-width: 768px) {
                    .awards-grid {
                        grid-template-columns: 1fr;
                        gap: 24px;
                    }
                    .award-item:not(:last-child)::after {
                        display: none;
                    }
                    .award-item:not(:last-child) {
                        border-bottom: 1px dashed #e2e8f0;
                        padding-bottom: 28px;
                    }
                }
            `}</style>
            <div className="awards-container">
                <div className="awards-grid">
                    {awardItems.map((item, i) => (
                        <div
                            key={i}
                            className="award-item"
                            onClick={() => navigate('/media-centre')}
                            role="button"
                            aria-label={`Go to Media Centre for ${item.text}`}
                        >
                            <div className="award-logos-wrapper">
                                {item.logo2 && (
                                    <img src={item.logo2} alt="award-logo-1" className="award-card-logo" />
                                )}
                                {item.logo && (
                                    <img src={item.logo} alt="award-logo-2" className="award-card-logo" />
                                )}
                            </div>
                            <div className="d-flex flex-column align-items-center">
                                <h3 className="award-card-text">{item.text}</h3>
                                <span className="award-card-subtext">{item.Subtext}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default MediaCentreSummary;